export default {
    debug: process.env.NODE_ENV != 'production',
    logPrefix: '[PolarisVue] ',
};



// WEBPACK FOOTER //
// ./src/config/config.js